import axiosInstance from './instance';

const instance = axiosInstance();
export const uplaodProfileShortListingDetails = async (data) => {
    try {
        const response = await instance.post(`/users/university-shortlisting-for-profile`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const postFoundSomethingWrong = async (newMessage) => {
    try {
        const response = await instance.post(`users/issue-resolution`,newMessage);
        return response;
    } catch (error) {
        return error;
    }
}
export const postAreYouLookingForSomeThingElse = async (newMessage) => {
    try {
        const response = await instance.post(`users/issue-resolution`,newMessage);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllProfileShortListingDetailsWithSort = async (page,size,sorter) => {
    try {
        const response = await instance.get(`/users/university-shortlisting-for-profile?page=${page}&size=${size}&sort=${sorter.fieldName},${sorter.direction}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllProfileShortListingDetails = async (page,size) => {
    try {
        const response = await instance.get(`/users/university-shortlisting-for-profile?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProfileShortListingDetails = async (id, data) => {
    console.log("updateProfileShortListingDetails",id)
    try {
        const response = await instance.put(`/users/university-shortlisting-for-profile/${id}`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const getProfileShortListingDetails = async (id) => {
    try {
        const response = await instance.get(`/users/university-shortlisting-for-profile/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getprofilesBasedOnStatus = async (status,page,size) => {
    try {
        const response = await instance.get(`/users/university-shortlisting-for-profile/user/${status}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const searchProfiles = async (data,page,size) => {
    try {
        const response = await instance.post(`/users/university-shortlisting-for-profile/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }

}
export const getAllIssuesSort = async (status,page,size,sorter) => {
    try {
        const response = await instance.get(`/users/issue-resolution/category/${status}?page=${page}&size=${size}&sort=${sorter.fieldName},${sorter.direction}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllIssues = async (category,page,size) => {
    try {
        const response = await instance.get(`/users/issue-resolution/category/${category}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllIssuesByStatus = async (status,category,page,size) => {
    try {
        const response = await instance.get(`/users/issue-resolution/${status}/${category}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const searchIssues = async (data,page,size) => {
    try {
        const response = await instance.post(`/users/issue-resolution/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateIssuesDetails = async (id, data) => {
    try {
        const response = await instance.put(`users/issue-resolution/${id}`, data);
        return response;
    } catch (error) {
        return error;
    }
}